import React from 'react';
import styled from '@emotion/styled';
import EmptyState from '../../../../components/Card/EmptyState';
import NotificationCard from '../../../../components/Card/NotificationCard';
import { useAppSelector } from '../../../../redux/store';
import DoubleCheckMark from '../../../../components/Icons/DoubleCheckMark';
import useMarkAllAsRead from '../../../../hooks/dashboard/notifications/dashboardNotifications/useMarkAllAsRead';
import { LoadingOutlined } from '@ant-design/icons';

const NotificationList = () => {
  const notifications = useAppSelector(
    (state) => state.notifications.notifications
  );
  const { loading: marking, markAllAsRead } = useMarkAllAsRead();

  // Determine if the "Mark all as Read" should be disabled.
  const isDisabled = notifications.length === 0;

  const handleMarkAll = () => {
    if (!isDisabled) {
      markAllAsRead();
    }
  };

  return (
    <Container>
      <Mark
        disabled={isDisabled}
        onClick={!isDisabled ? handleMarkAll : undefined}
      >
        Mark all as Read <DoubleCheckMark />
      </Mark>
      {marking ? (
        <LoadingOutlined />
      ) : notifications.length === 0 ? (
        <EmptyState>You currently do not have any notifications yet</EmptyState>
      ) : (
        notifications.map((data) => (
          <NotificationCard
            key={data.id}
            message={data.message}
            img={''}
            time={data.createdAt}
            type={data.type}
            id={data.id}
          />
        ))
      )}
    </Container>
  );
};

export default NotificationList;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 12px;
  margin-bottom: 54px;
`;

// Use the disabled prop to conditionally style the component.
const Mark = styled.div<{ disabled?: boolean }>`
  margin-top: 2rem;
  margin-left: 2rem;
  font-size: 1.05rem;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  gap: 0.5rem;
  text-decoration: underline;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  color: ${({ disabled }) => (disabled ? 'gray' : 'darkblue')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`;
